<template>
  <el-row align="middle" justify="center">
    <el-col txt-center :span="12">
      <router-link to="/signup/founder">
        <el-button type="primary" plain is-borderless>
          Create Founder Profile
        </el-button>
      </router-link>
    </el-col>
    <el-col txt-center :span="12">
      <el-link target="_blank" :href="aboutTalentsAccount"
        >Talents Get Invited ?</el-link
      >
    </el-col>
  </el-row>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},

})
export default class extends Vue {
  /**
   *
   */
  get aboutTalentsAccount(): string {
    return `${process.env.VUE_APP_BASE_URL_ABOUT}/talent`;
  }
}
</script>

<style lang="scss"></style>
